import { render, staticRenderFns } from "./ChangePersonalDataPopup.vue?vue&type=template&id=3db30a65&scoped=true"
import script from "./ChangePersonalDataPopup.vue?vue&type=script&lang=js"
export * from "./ChangePersonalDataPopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3db30a65",
  null
  
)

export default component.exports